module.exports = __webpack_public_path__ + "static/media/welcome.d7eff665.png";